import { Brand, createBranded } from '@deltasierra/type-utilities';
import { FullAuditable, HasId } from '../common';
import { IBuilderEmailDocument, TextSubstitutionValues } from '../builderDocument';
import { BuilderTemplateId } from '../builderTemplate';
import { LocationId } from '../location';

export interface FitwareAutomatedEmailTemplate extends HasId<FitwareAutomatedEmailTemplateId>, FullAuditable {
    builderTemplateId: BuilderTemplateId;
    builderDocument: IBuilderEmailDocument;
    fitwareTemplateId: number | null;
    locationId: LocationId;
    textSubstitutionValues: TextSubstitutionValues;
    status: 'finalised' | 'pending';
}

export type FitwareAutomatedEmailTemplateId = Brand<number, 'FitwareAutomatedEmailTemplateId'>;
export const FitwareAutomatedEmailTemplateId = createBranded<FitwareAutomatedEmailTemplateId>();
